import styled from 'styled-components'
import { media } from '../../Styles/media'


const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${media.desktop`
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  `}
`




export { Container }



// WEBPACK FOOTER //
// ./src/Components/ProjectGroup/styles.js